// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'typeface-muli';
import './i18n';
import './react-chartjs-2-defaults';
import './styles/index.css';
import App from 'app/App';
import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";

// if (process.env.REACT_APP_SENTRY_RELEASE) {
//   Sentry.init({
//     dsn: "https://1ceddf9f776541d682f30cec3bafb371@o4504791536959488.ingest.sentry.io/4504791540236288",
//     integrations: [new BrowserTracing()],
//     release: process.env.REACT_APP_SENTRY_RELEASE,
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     // We recommend adjusting this value in production
//     tracesSampleRate: 1.0,
//   });
// }

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
